import React, { Component } from 'react';
import Header from '../header';
import MetaTags from 'react-meta-tags';
import logo from '../common/app2soft/images/logo_color_140X40.png';
import Questions from './views/questions';
import * as DataStatic from '../../api/homeDataStatic';
import Footer from '../footer';
import RaisedButton from 'material-ui/RaisedButton';
import './style.scss';
// https://css-tricks.com/aos-css-driven-scroll-animation-library/
import AOS from 'aos';
import '../../../node_modules/aos/dist/aos.css'; 

import clientsImg from "../common/clients.jpg";
import clientCrEngland from "../common/crEnglandLogo.png";
import client1 from "../common/hanko.png";
import client2 from "../common/ken.png";
import client3 from "../common/rich.png";
import client4 from "../common/casselberry.png";


import teamImg from "../common/app2soft/images/team.jpg";
import imgAdam from "../common/app2soft/images/image003.jpg";
import imgJessica from "../common/app2soft/images/image002.png";
import imgCJ from "../common/app2soft/images/cj.jpg";

export default class x extends Component {
    constructor(props){
        super(props);
        this.handleClick = this.handleClick.bind();
        AOS.init();
    }

    componentWillReceiveProps (){ 
        AOS.refresh(); 
    } 

    componentDidMount(){
        // let pageName = this.props.match.params.name;
    }

    handleClick = () => {
        console.log( this )
        this.props.history.push("/build-your-team");
    }

    render(){
        const styles = {
            backgroundImage: `url(${teamImg})`,
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            backgroundPosition:'center',
            height: '550px'
        }
        const styleGrid = {
            width: "61.25rem",
            margin: " 100px auto"
        }
        return(
            <div key={`page-clients`}>
                <MetaTags>
                    <title>{`App2soft | Clients`}</title>
                    <meta name="description" content="" />
                    <meta name="keywords" content="" />
                    <meta name="author" content="Upway Solutions" />
                    <meta property="og:image" content={`${logo}`} />
                </MetaTags>
                <Header animation={false}/>
                <section className="page-clients">
                    <div className="page-title" style={styles}>
                        <div className="title" data-aos="fade-down"> 
                            <h2 data-aos="fade-up">Our people make us who we are awesome</h2>
                        </div>
                    </div>
                    <div className="main" data-aos="fade-down">
                        <div className="testimonials" data-aos="fade-up">
                            <div className="list">
                                <div className="item">
                                    <img src={`${imgCJ}`} alt="Image" width="163" height="168"/>
                                    <p>CJ Sanchez has been in Costa Rica for 20 years working in multiple technology fields. <br/><br/>He is an entrepreneur with a background in building an overseas NCO, as well as developing and managing virtual IT teams for companies like Pfiser, Del Monte, Motorola, Toshiba, and HP. Currently he’s managing the growing opportunities related to the expansion of App2Softs near-shoring and project based models for our United States Customers.<br/><br/>This includes employee hiring, call center management, talent acquisition, KPI’s and Metrics, Budgeting, and our external pricing model.
                                    <br/><br/><b>CJ Sanchez</b> <br/>Co-founder <br/><a href="mailto:cj.sanchez@app2soft.com">cj.sanchez@app2soft.com</a></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <div className="questions" data-aos="fade-up">
                    <h2>Build your online team</h2>
                    <RaisedButton label="Get Started" primary={true} onClick={ this.handleClick }/>
                </div>
                <Footer />
            </div>
        )
    }
}




// WEBPACK FOOTER //
// ./src/components/team/index.js